import tenantConstants from '@constants';
import { t as i18nT } from 'i18next';
import * as yup from 'yup';
import { emailValidationYup, stringValidationYup } from '../../../helpers';

// phoneValidationYup() in src/helpers only handles PK/SA country codes and returns
// undefined for OM, so we validate the Oman number against the tenant PHONE_REGEX here.
const omanPhoneValidationYup = () =>
  yup
    .string()
    .required(i18nT('Please enter your number'))
    .test('format', i18nT('Please enter a valid phone number'), (value) => {
      if (!value) return false;
      return tenantConstants.PHONE_REGEX ? tenantConstants.PHONE_REGEX.test(value) : true;
    });

export const buyPackageLeadFormFields = () => {
  return {
    name: {
      type: 'input',
      value: '',
      validation: () => stringValidationYup(i18nT('Please enter your full name')).nullable(),
      props: {
        label: 'Full Name',
        placeholder: 'Enter your full name',
        maxLength: 80,
        className: 'span-all',
      },
    },
    email: {
      type: 'input',
      value: '',
      validation: () => emailValidationYup(),
      props: {
        label: 'Email',
        placeholder: 'Enter your email',
        maxLength: 300,
        className: 'span-all',
      },
    },
    phone: {
      type: 'phone-input',
      value: '',
      validation: () => omanPhoneValidationYup(),
      props: {
        label: 'Phone Number',
        placeholder: 'Enter your phone number',
        defaultCountry: 'OM',
        countries: ['OM'],
        countrySelectProps: { disabled: true },
        countryCallingCodeEditable: false,
        className: 'span-all',
      },
    },
    nationality: {
      type: 'input',
      value: '',
      validation: () => stringValidationYup(i18nT('Please enter your nationality')).nullable(),
      props: {
        label: 'Nationality',
        placeholder: 'Enter your nationality',
        maxLength: 80,
        className: 'span-all',
      },
    },
    city: {
      type: 'input',
      value: '',
      validation: () => stringValidationYup(i18nT('Please enter your city')).nullable(),
      props: {
        label: 'City',
        placeholder: 'Enter your city',
        maxLength: 80,
        className: 'span-all',
      },
    },
  };
};
